<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="familiarForm">
        <v-container>
          <v-row>
            <v-col cols="6">
              <BaseInput v-model="familiar.nombre" :rules="required">
                <template v-slot:label>Nombre completo <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="maskedPhone" v-mask="'###-###-##-##'" maxlength="13" :rules="required">
                <template v-slot:label>Teléfono <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model.number="familiar.tiempoConocerse" type="number" min="0" :rules="required">
                <template v-slot:label>Tiempo de conocerse (años)<span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="familiar.comoConocio" :rules="required">
                <template v-slot:label>Cómo conoció a la persona <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="primary--text px-8 mb-4"
        :disabled="!familiarForm || loading"
        v-on:click="triggerSaveFamiliar()"
      >
        Registrar familiar
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import ReferenciaEntity from '@/modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS } from '@/modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
    },

    referencia: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      familiarForm: false,
      loading: false,
      maskedPhone: '',
      familiar: new ReferenciaEntity(TIPO_REFERENCIAS.PERSONAL),
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  mounted() {
    if (this.referencia) {
      this.familiar = { ...this.referencia }
      this.maskedPhone = this.referencia.telefono.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1-$2-$3-$4')
    }
  },

  methods: {
    ...mapActions('referenciaEnlaceC3', ['createReferencia', 'updateReferencia']),
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerSaveFamiliar() {
      try {
        this.loading = true
        this.familiar.telefono = this.maskedPhone.replace(/-/g, '')

        if (this.referencia) {
          await this.updateReferencia({ idPersonal: this.idPersonal, referencia: this.familiar })
        } else {
          await this.createReferencia({ idPersonal: this.idPersonal, referencia: this.familiar })
        }

        this.resetForm()
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar la referencia.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.familiar = new ReferenciaEntity()
      this.maskedPhone = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}
</style>
